import React from 'react';

export const USFlagArt: React.FC = () => (
  <>
    <circle cx="9.77756" cy="9.99826" r="8.88889" fill="#F2F0F2" />
    <mask
      id="mask0_5763_61814"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="1"
      width="19"
      height="18"
    >
      <circle cx="9.77756" cy="9.99826" r="8.88889" fill="#FCFCFC" />
    </mask>
    <g mask="url(#mask0_5763_61814)">
      <rect
        x="3.77734"
        y="16.8906"
        width="12.2222"
        height="2.22222"
        fill="#D90026"
      />
      <rect
        x="3.77734"
        y="16.8906"
        width="12.2222"
        height="2.22222"
        fill="#D90026"
      />
      <rect
        x="1.11133"
        y="12.4453"
        width="17.5556"
        height="2.22222"
        fill="#D90026"
      />
      <rect
        x="1.11133"
        y="12.4453"
        width="17.5556"
        height="2.22222"
        fill="#D90026"
      />
      <rect
        x="1.11133"
        y="7.77344"
        width="17.5556"
        height="2.22222"
        fill="#D90026"
      />
      <rect
        x="1.11133"
        y="7.77344"
        width="17.5556"
        height="2.22222"
        fill="#D90026"
      />
      <rect
        x="1.11133"
        y="3.32812"
        width="17.5556"
        height="2.22222"
        fill="#D90026"
      />
      <rect
        x="1.11133"
        y="3.32812"
        width="17.5556"
        height="2.22222"
        fill="#D90026"
      />
      <rect
        x="0.888672"
        y="1.10938"
        width="9.11111"
        height="8.88889"
        fill="#0052B5"
      />
      <path
        d="M8.22287 8.55382L7.55621 8.88715L7.77843 8.22049L7.33398 7.77604H8.00065L8.22287 7.10938L8.55621 7.77604H9.11176L8.66732 8.22049L8.88954 8.88715L8.22287 8.55382Z"
        fill="#EFEFEF"
      />
      <path
        d="M5.11155 8.55382L4.44488 8.88715L4.6671 8.22049L4.22266 7.77604H4.88932L5.11155 7.10938L5.44488 7.77604H6.00043L5.55599 8.22049L5.77821 8.88715L5.11155 8.55382Z"
        fill="#EFEFEF"
      />
      <path
        d="M2.00022 8.55382L1.33355 8.88715L1.55577 8.22049L1.11133 7.77604H1.77799L2.00022 7.10938L2.33355 7.77604H2.88911L2.44466 8.22049L2.66688 8.88715L2.00022 8.55382Z"
        fill="#EFEFEF"
      />
      <path
        d="M8.22287 6.10851L7.55621 6.44184L7.77843 5.77517L7.33398 5.33073H8.00065L8.22287 4.66406L8.55621 5.33073H9.11176L8.66732 5.77517L8.88954 6.44184L8.22287 6.10851Z"
        fill="#EFEFEF"
      />
      <path
        d="M8.22287 3.66319L7.55621 3.99653L7.77843 3.32986L7.33398 2.88542H8.00065L8.22287 2.21875L8.55621 2.88542H9.11176L8.66732 3.32986L8.88954 3.99653L8.22287 3.66319Z"
        fill="#EFEFEF"
      />
      <path
        d="M8.22287 1.21788L7.55621 1.55122L7.77843 0.884549L7.33398 0.440104H8.00065L8.22287 -0.226562L8.55621 0.440104H9.11176L8.66732 0.884549L8.88954 1.55122L8.22287 1.21788Z"
        fill="#EFEFEF"
      />
      <path
        d="M5.11155 3.66319L4.44488 3.99653L4.6671 3.32986L4.22266 2.88542H4.88932L5.11155 2.21875L5.44488 2.88542H6.00043L5.55599 3.32986L5.77821 3.99653L5.11155 3.66319Z"
        fill="#EFEFEF"
      />
      <path
        d="M5.11155 6.10851L4.44488 6.44184L4.6671 5.77517L4.22266 5.33073H4.88932L5.11155 4.66406L5.44488 5.33073H6.00043L5.55599 5.77517L5.77821 6.44184L5.11155 6.10851Z"
        fill="#EFEFEF"
      />
      <path
        d="M2.00022 6.10851L1.33355 6.44184L1.55577 5.77517L1.11133 5.33073H1.77799L2.00022 4.66406L2.33355 5.33073H2.88911L2.44466 5.77517L2.66688 6.44184L2.00022 6.10851Z"
        fill="#EFEFEF"
      />
    </g>
  </>
);

USFlagArt.displayName = 'USFlagArt';
